module.exports = __webpack_public_path__ + "static/media/kc_background.806845ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/kc_background.png
// module id = 2530
// module chunks = 0